import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'reactstrap/lib/Dropdown';
import DropdownToggle from 'reactstrap/lib/DropdownToggle';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import DropdownItem from 'reactstrap/lib/DropdownItem';
import { SORT_CONFIG } from 'client/constants/dealer-reviews';

import './sort-reviews-dropdown.scss';

export function SortReviewsDropdown({ onSortChange }) {
  const [isSortDropdownOpen, setSortDropdownOpen] = useState(false);
  const [sortLabel, setSortLabel] = useState('Newest');

  const toggleSortDropdown = useCallback(() => {
    setSortDropdownOpen(prev => !prev);
  }, []);

  const handleSortClick = useCallback(
    ({ target: { value } }) => {
      const config = SORT_CONFIG[value];
      setSortLabel(value);
      onSortChange(config);
    },
    [onSortChange]
  );

  return (
    <div className="sort-reviews-dropdown d-flex align-items-center">
      <span className="size-14 text-cool-gray-30 me-0_25">Sort by:</span>
      <Dropdown
        isOpen={isSortDropdownOpen}
        toggle={toggleSortDropdown}
        className="d-inline-block size-14 text-cool-gray-30"
      >
        <DropdownToggle
          caret
          color="text-cool-gray-30"
          className="fw-bold d-inline-block pe-1_5 ps-0 pt-0 pb-0 size-14 text-cool-gray-30 bg-none text-transform-none"
        >
          {sortLabel}
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem onClick={handleSortClick} value="Newest">
            Newest
          </DropdownItem>
          <DropdownItem onClick={handleSortClick} value="Highest">
            Highest
          </DropdownItem>
          <DropdownItem onClick={handleSortClick} value="Lowest">
            Lowest
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

SortReviewsDropdown.propTypes = {
  onSortChange: PropTypes.func.isRequired,
};
